/* import __COLOCATED_TEMPLATE__ from './predicates-editor-side-sheet.hbs'; */
/* RESPONSIBLE TEAM: team-fin-qa */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { action } from '@ember/object';
//@ts-ignore no type declaration available for ember-copy
import { copy } from 'ember-copy';
import type ReactTeammateAppIslandService from 'embercom/services/react-teammate-app-island';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    onClose: () => void;
    isOpen: boolean;
    predicateGroup?: $TSFixMe;
    finInvolvedPredicates?: unknown[];
  };
}

export default class PredicatesEditorSideSheet extends Component<Signature> {
  @service declare attributeService: $TSFixMe;
  @service declare appService: $TSFixMe;
  @service declare intl: $TSFixMe;
  @service declare reactTeammateAppIsland: ReactTeammateAppIslandService;

  private _buildBaseAttributes(): $TSFixMe[] {
    let aiTopicDescriptorIds = new Set(['ai_insights_topic', 'ai_insights_subtopic_ids']);
    let canSeeAiTopics = this.appService.app.canSeeAiTopics;

    let nonClassificationCustomAttributes =
      this.attributeService.nonArchivedConversationCustomAttributes.filter(
        (attr: $TSFixMe) =>
          !attr.get('isClassificationAttribute') &&
          (canSeeAiTopics ||
            !aiTopicDescriptorIds.has(
              attr.get('identifier')?.replace('conversation.custom_attribute.', ''),
            )),
      );

    let conversationAttributes = [
      ...this.attributeService.assignmentRulesMessageAttributesAsAttributes,
      ...this.attributeService.assigneeAttributes,
      ...this.attributeService.outboundSupportConversationAttributes,
      ...nonClassificationCustomAttributes,
    ];

    let allAttributes = [
      ...this.attributeService.conversationChannelAttributes,
      ...conversationAttributes,
      ...this.attributeService.filterableUserAttributesForMessaging,
    ];

    if (this.appService.app.companiesActive) {
      allAttributes = allAttributes.concat(
        this.attributeService.filterableCompanyAttributesForMessaging,
      );
    }

    return allAttributes;
  }

  get attributeListOverride() {
    return this._buildBaseAttributes();
  }

  get attributeGroupList() {
    let allAttributes = this._buildBaseAttributes();
    let attributeGroups = this.attributeService.attributesToGroupList(allAttributes);

    if (this.attributeService.ticketAttributesByType?.length > 0) {
      attributeGroups = attributeGroups.concat(this.attributeService.ticketAttributesByType);
    }

    return attributeGroups;
  }

  get predicateContext() {
    return {
      mode: 'rules',
    };
  }

  @action
  onPredicatesUpdate(predicates: $TSFixMe[]) {
    if (!this.args.predicateGroup) {
      return;
    }

    this.args.predicateGroup.set('predicates', copy(predicates));
  }

  @action
  savePredicates() {
    if (!this.args.predicateGroup) {
      return;
    }

    let predicates = this.args.predicateGroup.predicates.serialize() || [];
    let finInvolvedPredicates = this.args.finInvolvedPredicates || [];

    this.reactTeammateAppIsland.dispatchBridgeEvent('teammate-app:event', {
      identifier: 'fin-qa-monitor:predicates:updated',
      data: {
        predicates: [...predicates, ...finInvolvedPredicates],
      },
    });

    this.args.onClose();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'FinQaMonitor::PredicatesEditorSideSheet': typeof PredicatesEditorSideSheet;
    'fin-qa-monitor/predicates-editor-side-sheet': typeof PredicatesEditorSideSheet;
  }
}
